<template>
  <div class="mb-5 rounded-lg bg-gray-50 border border-gray-100 overflow-hidden">
    <div class="px-3 py-3 flex items-center justify-between">
      <h3 class="text-[13px] font-bold text-gray-800">我的遊戲ID</h3>
      <button
        type="button"
        class="text-[12px] font-bold text-primary"
        @click="openManager"
      >
        管理
      </button>
    </div>

    <div v-if="loading" class="px-3 pb-3 text-[12px] text-gray-400">
      載入中...
    </div>

    <div v-else-if="records.length" class="px-3 pb-3 flex space-x-2 overflow-x-auto scrollbar-hide">
      <button
        v-for="record in records"
        :key="record.id"
        type="button"
        class="flex-none max-w-[180px] text-left px-3 py-2 rounded-md border border-gray-200 bg-white active:bg-primary/5"
        :disabled="applying"
        @click="apply(record)"
      >
        <p class="text-[13px] font-bold text-gray-800 truncate">
          {{ record.label || '遊戲ID' }}
        </p>
        <p class="mt-1 text-[11px] text-gray-500 truncate">
          {{ record.summary }}
        </p>
      </button>
    </div>

    <div v-else class="px-3 pb-3 text-[12px] leading-5 text-gray-500">
      完成購買後會自動記住，下次可直接選用。
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    categoryId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      records: [],
      loading: false,
      applying: false,
    };
  },
  watch: {
    categoryId: {
      immediate: true,
      handler() {
        this.fetchRecords();
      },
    },
  },
  methods: {
    ...mapActions({
      closePopup: "popup/close",
    }),
    openManager() {
      this.closePopup();
      this.$router.push(this.localePath("/game-ids"));
    },
    async fetchRecords() {
      if (!this.$auth.loggedIn || !this.categoryId) return;

      this.loading = true;
      try {
        const { data } = await this.$axios.$get('/api/game-ids', {
          params: {
            category_id: this.categoryId,
          },
        });
        this.records = data;
      } catch (e) {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    async apply(record) {
      this.applying = true;
      try {
        const { data } = await this.$axios.$get(`/api/game-ids/${record.id}`);
        this.$emit('apply', data.options || {});
      } catch (e) {
        this.$loader.error('未能套用遊戲ID');
      } finally {
        this.applying = false;
      }
    },
  },
};
</script>
